import MessageOutlinedIcon from '@ant-design/icons/MessageOutlined'
import PhoneOutlinedIcon from '@ant-design/icons/PhoneOutlined'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'

import useUserSetting from '@shared/hooks/src/useUserSetting'
import { checkMessagingAvailability } from '@shared/messaging/src/Helper'
import { useGetConversationId } from '@shared/messaging/src/hooks'
import { ContactMethod, UserRole, UserSettingName } from '@shared/utils'

import { usePatientDirectCall, useUserDirectCall } from '@providers/VoiceCallProvider'

export default function CommunicationActions({ user }) {
  const { makeCall: callPatient, disabled: patientCallDisabled } = usePatientDirectCall(user)
  const { makeCall: callUser, disabled: userCallDisabled } = useUserDirectCall(user)
  const getConversationId = useGetConversationId({ userId: user?.id }, { skipHandling: true })

  const contactMethodSetting = useUserSetting(user, UserSettingName.ContactMethod)
  const [canMessage, description] = checkMessagingAvailability(user)
  const isPatient = user?.role === UserRole.Patient
  const contactMethod = contactMethodSetting?.value
  const callDisabled = patientCallDisabled || userCallDisabled
  const disabled = !user || user.disabled

  const handleMessage = () => {
    getConversationId.mutate(undefined, {
      onSuccess: (data) => window.open(`${import.meta.env.VITE_URL}/app/conversations/${data.conversation?.id}`, '_blank'),
    })
  }

  const handleCall = () => {
    if (isPatient) return callPatient()
    return callUser()
  }

  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title={description}>
        <Box sx={{ width: '100%' }}>
          <Button
            fullWidth
            disabled={disabled || !canMessage}
            variant={contactMethod === ContactMethod.Email ? 'contained' : 'outlined'}
            color="primary"
            startIcon={<MessageOutlinedIcon />}
            onClick={handleMessage}
          >
            Message
          </Button>
        </Box>
      </Tooltip>
      <Tooltip title={callDisabled ? `${isPatient ? 'Patient is disabled or' : 'User'} doesn't have phone number on file` : ''}>
        <Box sx={{ width: '100%' }}>
          <Button
            fullWidth
            disabled={disabled || callDisabled}
            variant={contactMethod === ContactMethod.Phone ? 'contained' : 'outlined'}
            color="primary"
            startIcon={<PhoneOutlinedIcon />}
            onClick={handleCall}
          >
            Call
          </Button>
        </Box>
      </Tooltip>
    </Stack>
  )
}
